import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AuthService, GlobalMessageService, WindowRef, StateWithClientAuth, AuthActions,
  OAuthLibWrapperService, AuthConfig,
  OCC_USER_ID_ANONYMOUS
} from '@spartacus/core';

import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { ToastrService } from 'ngx-toastr';
import InventoryManagementService from 'src/app/modules/custom-landing/inventory-unpublished-batch/inventory-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import {  UserIdService } from '@spartacus/core';
import { OAuthStorage, DateTimeProvider } from 'angular-oauth2-oidc';
import { CsAgentAuthService, AsmAuthStorageService } from '@spartacus/asm/root';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from 'src/app/core/constants/url.constants';
import { ToastService } from 'src/app/core/services/toaster.service';
import { CustomLoginService} from '../../custom-login/custom-login-form/custom-login.service'
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-custom-asmlogin',
    templateUrl: './custom-asmlogin.component.html',
    styleUrl: './custom-asmlogin.component.scss'
})
export class CustomASMLoginComponent implements OnInit {
  notASM:boolean = true;
  inventoryIdToken:any;
  BASE_URL = environment.baseUrl;
  constructor(protected auth: AuthService, private csAgentAuthService: CsAgentAuthService,
    private dateTimeService: DateTimeProvider,
    private customLoginService: CustomLoginService,
    protected globalMessageService: GlobalMessageService,

    protected winRef: WindowRef,
    private router: Router,

    private cd: ChangeDetectorRef,
    private toastService: ToastrService,
    public ModalService: NgbModal,
    protected store: Store<StateWithClientAuth>,
    private userIdService: UserIdService, private asmauthstorage: AsmAuthStorageService,
    private oauthStorage: OAuthStorage, protected oAuthLibWrapperService: OAuthLibWrapperService,
    private httpClient: HttpClient, public authcon: AuthConfig, private activatedRoute: ActivatedRoute,
    private toast: ToastService) {

  }
  showMessage:string='';
  loginmessage:string="To view customer's account, enter their email address in the box above and click Start Session."
  logoutMessage:string ="This session has expired. To start a new session, go back to BHP Connect Backoffice and click the Customer view tile."
  ngOnInit(): void {
    let token = this.activatedRoute.snapshot.queryParams['token'];
    if (token != undefined) {
      localStorage.setItem('inventoryIdToken', token);
      this.router.navigate([], { queryParams: {} });
      this.notASM = false;
    }
    this.getASMAcess();
    this.inventoryIdToken = localStorage.getItem('inventoryIdToken');
    if (this.inventoryIdToken != undefined && this.inventoryIdToken != null) {
      this.showMessage = this.loginmessage;
      this.loginUserFromMFA();
    }else{
      this.showMessage = this.logoutMessage;
      localStorage.clear();
    }
  }
  protected loginUserFromMFA() {
    let params = new HttpParams({})
      .set('grant_type', 'authorization_code')
      .set('scope', 'extended');
    params = params.set('client_id', 'asagent');
    params = params.set('client_secret', 'secret');
    params = params.set('code', this.inventoryIdToken);
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');
    this.httpClient.post(this.BASE_URL + Constants.ONLYTOKEN, params, { headers }).subscribe((response: any) => {
      if (response) {
        localStorage.removeItem('inventoryIdToken');
        this.storeAccessTokenResponse(response.access_token, response.refresh_token, response.expires_in, response.scope, null)
        this.userIdService.setUserId(OCC_USER_ID_ANONYMOUS);
        this.store.dispatch(new AuthActions.Login());
        this.asmauthstorage.switchTokenTargetToCSAgent();
        this.csAgentAuthService.isCustomerEmulated().subscribe(res => {
          console.log(res);
          if (res == true) {
            this.getASMAcess()
            this.router.navigate(['/'], { skipLocationChange: true });
          }
        })
      } else {
        this.toastService.show('Response not returned from backend while accessing the token')
      }

    }, err => {
      localStorage.removeItem('inventoryIdToken');
      this.toastService.show('API error occurred while getting the token, please contact support team');
    });
  }
  getASMAcess() {
    this.customLoginService.getASMAcess().subscribe(res => {
      if (res) {
        this.customLoginService.setASMObject(res);
        //this.isAsmAccess = res.isASMEligible;
      }
      else {
        this.toast.show('ASM object is not returned, please contact support team');
      }

    }, error => {
      this.toast.show('API error while fetching ASM access, please contact support team.');
    })
  }
  storeAccessTokenResponse(accessToken, refreshToken, expiresIn, grantedScopes, customParameters) {
    this.oauthStorage.setItem('access_token', accessToken);
    if (grantedScopes && !Array.isArray(grantedScopes)) {
      this.oauthStorage.setItem('granted_scopes', JSON.stringify(grantedScopes.split(' ')));
    }
    else if (grantedScopes && Array.isArray(grantedScopes)) {
      this.oauthStorage.setItem('granted_scopes', JSON.stringify(grantedScopes));
    }
    this.oauthStorage.setItem('access_token_stored_at', '' + this.dateTimeService.now());
    if (expiresIn) {
      const expiresInMilliSeconds = expiresIn * 1000;
      const now = this.dateTimeService.new();
      const expiresAt = now.getTime() + expiresInMilliSeconds;
      this.oauthStorage.setItem('expires_at', '' + expiresAt);
    }
    if (refreshToken) {
      this.oauthStorage.setItem('refresh_token', refreshToken);
    }
    if (customParameters) {
      customParameters.forEach((value, key) => {
        this.oauthStorage.setItem(key, value);
      });
    }
  }
}
